import { $ } from '@/Engine/stateInstance';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import { Group, Mesh } from 'three';
import { textMaterial } from '@/Engine/Ruler/material';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
import { textFrameName, textMeshName } from '@/Constants/common';



export class TextMesh {
    private loader = new FontLoader();
    readonly model: Group=new Group();
    textMesh!: Mesh;
    textPlane!: Mesh;
    text: string;
    textGeometry: TextGeometry;

    constructor(text:string) {
        if (!$.font) return;
        if (!$.v3dTools) return;
        this._makeMesh(text);
    }

    _makeMesh(text: string) {
        const modelProto = $.v3dTools.getObjectByName(textFrameName);
        const textProto = $.v3dTools.getObjectByName(textMeshName);
        if (!modelProto) {
            console.warn('modelProto is not defined: ', textFrameName);
            return;
        }

        if (!textProto) {
            console.warn('textProto is not defined: ', textMeshName);
            return;
        }

        modelProto.visible = false;
        textProto.visible = false;

        this.textPlane = modelProto.clone();
        this.textMesh = textProto.clone();
        this.textPlane.visible = true;
        this.textMesh.visible = true;

        this.textPlane.position.set(0, 0, 0);
        // this.textMesh.parent.renderOrder = 100;

        const setMaterialProps = (obj: Mesh) => {
            if (obj.material) {
                if (Array.isArray(obj.material)) {
                    obj.material.forEach(m => {
                        m.depthTest = false;
                        m.depthWrite = false;
                    });
                } else {
                    obj.material.depthTest = false;
                    obj.material.depthWrite = false;
                }
            }
        };

        setMaterialProps(this.textMesh);
        setMaterialProps(this.textPlane);

        this.textMesh.renderOrder = 150;
        this.textPlane.renderOrder = 100;

        this._updateTextGeometry(this.textMesh, text);

        this.model.add(this.textMesh);
        this.model.add(this.textPlane);
        this.text = text;
    }

    getTextGeometry(text: string) {
        if (!$.font) return;
        return new TextGeometry(text, {
            font: $.font,
            size: 0.03,
            height: 0.001,
            curveSegments: 5,
        });
    }

    _updateTextGeometry(obj: Mesh, text: string) {
        const geometry = this.getTextGeometry(text);
        if (geometry) {
            if (obj.geometry) obj.geometry.dispose();
            obj.geometry = geometry;
        }
    }

    update(text: string) {
        if (!$.v3dTools) return;
        if (this.text === text) return;
        this.text = text;
        // const geometry = this.getTextGeometry(text);
        // if (!geometry) return;
        if (!this.textMesh) {
            this._makeMesh(text);
            return;
            // const modelProto = $.v3dTools.getObjectByName('size_plane');
            // if (!modelProto) {return;}
            //
            // this.textMesh = modelProto.clone();
            // this.textMesh = new Mesh(geometry, textMaterial);
            // this.textMesh.scale.set(1,1,0.002);
            // this.textMesh.renderOrder = 100;
            // this.model.add(this.textMesh);
        }

        this._updateTextGeometry(this.textMesh, text);
    }

}

